import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")

import { ref, reactive, inject } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import dayjs from 'dayjs'
import { formatNumber } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  emits: ['switchPage'],
  setup(__props, { emit }) {

const {
  'POST/procures/statistics': fetchList,
} = Api


const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

const invCompList = inject('invCompList')
const companyList = inject('companyList')

const searchEle = ref()
const searchObj = reactive({
  invoiceCompany: '',
  company: '',
  deliverTimeRange: [dayjs().subtract(1, 'year').startOf('year').format('YYYY-MM-DD'), dayjs().endOf('year').format('YYYY-MM-DD')], 
})
const searchHandle = () => {
  fetchData({
    ...searchObj,
    deliverTimeRange: {
      from: searchObj.deliverTimeRange?.[0],
      to: searchObj.deliverTimeRange?.[1]
    }
  })
}
searchHandle()


const switchPageHandle = (row: any, column: any) => {
  const monthRange = [
    dayjs(row.accountMonth).startOf('month').format('YYYY-MM-DD'),
    dayjs(row.accountMonth).endOf('month').format('YYYY-MM-DD')
  ]

  if(column.property === 'domesticTotalCredit'){
    emit('switchPage', {
      ...MI_params,
      domestic: 1,
      monthRange,
    })
  }
  if(column.property === 'abroadTotalCredit'){
    emit('switchPage', {
      ...MI_params,
      domestic: 0,
      monthRange,
    })
  }
  if(column.property === 'domesticProcureAmount'){
    emit('switchPage', {
      ...MI_params,
      domestic: 0,
      existProcure: 1,
      monthRange,

    })
  }
  if(column.property === 'abroadProcureAmount'){
    emit('switchPage', {
      ...MI_params,
      domestic: 1,
      existProcure: 1,
      monthRange,
    })
  }
  if(column.property === 'domesticNotAmount'){
    emit('switchPage', {
      ...MI_params,
      domestic: 0,
      existProcure: 0,
      monthRange,
    })
  }
  if(column.property === 'abroadNotAmount'){
    emit('switchPage', {
      ...MI_params,
      domestic: 1,
      existProcure: 0,
      monthRange,
    })
  }
}


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form, {
      ref_key: "searchEle",
      ref: searchEle,
      model: _unref(searchObj),
      inline: "",
      class: "searchBg mb-10"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "成本公司:",
          prop: "company"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              class: "form-input",
              modelValue: _unref(searchObj).company,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchObj).company) = $event)),
              clearable: "",
              filterable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(companyList), (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item,
                    value: item,
                    label: item
                  }, null, 8, ["value", "label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "发票主体:",
          prop: "invoiceCompany"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              class: "form-input",
              modelValue: _unref(searchObj).invoiceCompany,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchObj).invoiceCompany) = $event)),
              clearable: "",
              placeholder: "请选择发票主体",
              filterable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(invCompList), (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item,
                    value: item,
                    label: item
                  }, null, 8, ["value", "label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "日期:",
          prop: "deliverTimeRange"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_date_picker, {
              modelValue: _unref(searchObj).deliverTimeRange,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchObj).deliverTimeRange) = $event)),
              "range-separator": "至",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              clearable: false,
              type: "monthrange",
              "value-formatter": "YYYY-MM-DD"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: searchHandle
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (searchEle.value.resetFields()))
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      onRowDblclick: switchPageHandle,
      "max-height": _unref(MI_height) + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "财务成本日期",
          prop: "accountMonth",
          fixed: "",
          "min-width": "110"
        }),
        _createVNode(_component_el_table_column, {
          label: "总成本",
          align: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "境内",
              prop: "domesticTotalCredit",
              align: "right",
              "min-width": "120",
              "show-overflow-tooltip": "",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "境外",
              prop: "abroadTotalCredit",
              align: "right",
              "min-width": "120",
              "show-overflow-tooltip": "",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "已经采购",
          align: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "境内",
              prop: "domesticProcureAmount",
              align: "right",
              "min-width": "120",
              "show-overflow-tooltip": "",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "境外",
              prop: "abroadProcureAmount ",
              align: "right",
              "min-width": "120",
              "show-overflow-tooltip": "",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "尚未采购",
          align: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "境内",
              prop: "domesticNotAmount",
              align: "right",
              "min-width": "120",
              "show-overflow-tooltip": "",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "境外",
              prop: "abroadNotAmount",
              align: "right",
              "min-width": "120",
              "show-overflow-tooltip": "",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ])
  ]))
}
}

})